/*
    Config file for Select2
 */
export const options = {
    theme: 'bootstrap4',
    language: 'fr'
}